export class ServerError extends Error {
	code: string

	constructor(code: string, message: string) {
		super(message)
		this.code = code
	}
}

export default async function simpleFetch<Type>(
	url: string,
	payload?: unknown,
	method = 'POST',
	options?: RequestInit,
): Promise<Type> {
	let body: string | FormData | undefined
	let headers: Record<string, string> | undefined

	if (payload instanceof FormData) {
		body = payload
	} else if (typeof payload === 'string') {
		body = payload
		headers = { 'Content-Type': 'application/json' }
	} else if (payload) {
		body = JSON.stringify(payload)
		headers = { 'Content-Type': 'application/json' }
	}

	const response = await fetch(url, {
		credentials: 'same-origin',
		method,
		headers,
		body,
		...options,
	})

	if (!response.ok || response.status >= 400) {
		const data = await response.json()
		if (data?.success === false && data.error) {
			if (data.error.code === 'NO_SESSION') {
				window.location.href = '/auth/login.html'
			}
			throw new ServerError(data.error.code, data.error.message)
		}
		throw new Error(`${response.status}: ${response.statusText}`)
	}

	return response.json() as Type
}

export function get<T>(url: string, searchParams?: URLSearchParams): Promise<T> {
	if (searchParams) {
		const search = searchParams.toString()
		if (search) {
			url += '?' + search
		}
	}
	return simpleFetch<T>(url, null, 'GET')
}

export function post<T, P = unknown>(url: string, payload?: P, options?: RequestInit): Promise<T> {
	return simpleFetch<T>(url, payload, 'POST', options)
}

export function put<T, P = unknown>(url: string, payload?: P, options?: RequestInit): Promise<T> {
	return simpleFetch<T>(url, payload, 'put', options)
}

export function del<T, P = unknown>(url: string, payload?: P, options?: RequestInit): Promise<T> {
	return simpleFetch<T>(url, payload, 'DELETE', options)
}
